import { Injectable } from '@angular/core';
import { ApolloLink } from '@apollo/client';
import { getOperationDefinition } from '@apollo/client/utilities';
import { OperationTypeNode } from 'graphql';

import { ApolloLinkProvider } from '@shure/shared/angular/data-access/system-api/core';
import { ILogger } from '@shure/shared/angular/utils/logging';

import { SysApiDeviceAuthenticationKeyringService } from './sys-api-device-authentication-keyring.service';

@Injectable({ providedIn: 'root' })
export class SysApiDeviceAuthenticationKeyringInjector implements ApolloLinkProvider {
	private readonly logger: ILogger;

	constructor(
		logger: ILogger,
		private readonly sysApiDeviceAuthenticationKeyringService: SysApiDeviceAuthenticationKeyringService
	) {
		this.logger = logger.createScopedLogger('SysApiDeviceAuthenticationKeyringInjector');
	}

	public createApolloLink(): { link: ApolloLink; priority: number } {
		const link = new ApolloLink((operation, forward) => {
			// Called before operation is sent to server
			const definition = getOperationDefinition(operation.query);
			if (
				(definition?.operation === OperationTypeNode.MUTATION ||
					definition?.operation === OperationTypeNode.SUBSCRIPTION) &&
				'injectKeyring' in operation.variables
			) {
				this.logger.trace('authenticationApolloLink()', 'Updating keyring variable', {
					operation,
					variables: operation.variables
				});
				// eslint-disable-next-line dot-notation
				operation.variables['injectKeyring'] = this.sysApiDeviceAuthenticationKeyringService.getForMutation();
			}
			return forward(operation);
		});
		return { link, priority: 10 };
	}
}
